module.exports = __webpack_public_path__ + "static/media/varify-badge-step1-mobile.b7fa33a2.png";